import React from 'react'

import styles from './error.module.css'

export const Error = ({ children }: { children: string }): JSX.Element => (
  <span className={styles.error}>{children}</span>
)
